// O lucide-react não traz um ícone de TikTok. Este SVG segue o mesmo grid dos ícones
// lucide usados ao lado (viewBox 24x24, traço de 2, currentColor, sem preenchimento)
// para não destoar — o glifo oficial é preenchido e ficaria pesado entre quatro
// ícones de traço.
export const TikTokIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    <path d="M15 3v10.5a4.5 4.5 0 1 1-4.5-4.5" />
    <path d="M15 6.5a5 5 0 0 0 5 4" />
  </svg>
);
